export default __webpack_public_path__ + "static/media/i03.cd2b0745.gif";